import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import AdminCashBuyers from "@/pages/AdminCashBuyers";
import AdminDeals from "@/pages/AdminDeals";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin/leads" element={<Admin />} />
          <Route path="/admin/cash-buyers" element={<AdminCashBuyers />} />
          <Route path="/admin/deals" element={<AdminDeals />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
